import React from "react";
import type { FormSubmitValue } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/types";
import type { ApiResponse } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/types";

import { Container, OrDivider, StyledEmailForm, StyledSocialButtons } from "./styles";

export type Props = {
  isAgreedReceiveMarketing: boolean;
  onSubmit: (form: FormSubmitValue) => Promise<ApiResponse>;
};

export const CombinedSocialAndEmail: React.FunctionComponent<Props> = ({
  isAgreedReceiveMarketing,
  onSubmit,
  ...props
}) => (
  <Container {...props}>
    <StyledSocialButtons
      isAgreedReceiveMarketing={isAgreedReceiveMarketing}
      onEmailClick={() => {}}
      showEmailIcon={false}
    />
    <OrDivider>or</OrDivider>
    <StyledEmailForm onSubmit={onSubmit} showBackButton={false} />
  </Container>
);

CombinedSocialAndEmail.displayName = "CombinedSocialAndEmail";
